<script>
export default {
  data() {
    return {
      checkError: false,
    }
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    secondTitle: {
      type: String,
      default: '',
    },
    subLabel: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    inputType: {
      type: String,
      default: 'text',
    },
    isPrice: {
      default: false,
      type: Boolean,
    },
    minlength: {
      type: Number,
    },
    maxlength: {
      type: Number,
      default: 50,
    },
    id: {
      type: String,
    },
    classes: {
      type: String,
      default: '',
    },
    labelClass: {
      type: String,
      default: '',
    },
    secondLabelClass: {
      type: String,
      default: '',
    },
    subLabelClass: {
      type: String,
      default: '',
    },
    disable: {
      type: Boolean,
      default: false,
    },
    value: {
      default: null,
    },
    required: {
      type: Boolean,
      default: false,
    },
    showError: {
      type: Boolean,
      default: false,
    },
    errortext: {
      type: String,
      default: '',
    },
  },
  computed: {
    inputVal: {
      get() {
        return this.value
      },
      set(val) {
        if (val.length > 0) {
          this.checkError = false
        }
        this.$emit('input', val)
      },
    },
  },
  watch: {
    showError(c) {
      this.checkError = c
    },
  },
  methods: {
    enterClicked() {
      this.$emit('enterButton')
    },
    focused() {
      this.$emit('focused')
    },
    inpNum(e) {
      if (this.inputType === 'number') {
        e = e || window.event
        const charCode = typeof e.which == 'undefined' ? e.keyCode : e.which
        const charStr = String.fromCharCode(charCode)
        if (!charStr.match(/^[0-9]+$/)) e.preventDefault()
      }
    },
  },
}
</script>

<template>
  <div :style="disable ? 'opacity: 0.5' : ''">
    <div class="mainInput" :class="classes">
      <div class="label">
        <div v-if="title != ''" class="labelStyle" :class="labelClass" :style="title.length > 12 ? `whiteSpace: nowrap; font-size: 12px` : { whiteSpace: 'none' }">{{ title }}</div>

        <div
          v-if="secondTitle != ''"
          class="secondLabelStyle"
          :class="secondLabelClass"
          :style="secondTitle.length > 12 ? `whiteSpace: nowrap; font-size: 12px` : { whiteSpace: 'none' }"
        >
          {{ `(${secondTitle})` }}
        </div>
      </div>
      <div class="w-100 position-relative">
        <b-form-input
          :id="id"
          :class="showError ? `errorStyle` : disable ? `disableInput` : `inputStyle`"
          autocomplete="off"
          :maxlength="maxlength"
          @focus="focused()"
          :minlength="minlength"
          oninput="javascript: if (this.type == 'number') { if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);}"
          v-model="inputVal"
          :type="inputType"
          @change="enterClicked"
          :placeholder="placeholder"
          :required="required"
          :disabled="disable"
          @keypress="inpNum($event)"
          :style="required && 'border-right: 4px solid #fe5e61;'"
        ></b-form-input>
        <div v-if="showError" class="errorClass">{{ errortext }}</div>

        <div v-if="subLabel != ''" class="subLabelStyle" :class="subLabelClass">
          {{ subLabel }}
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.mainInput {
  display: flex;
  align-items: center;
}
.inputStyle {
  width: 100%;
  color: #74788d;
  background: #ffffff;
  border: 1px solid #ced4da;
  padding: 6px 10px;
  box-sizing: border-box;
}
.disableInput {
  width: 100%;
  color: #c6cbd0;
  background: #ffffff;
  border: 1px solid #ced4da;
  padding: 6px 10px;
  box-sizing: border-box;
}
.errorStyle {
  line-height: 17px;
  width: 100%;
  color: #74788d;
  background: #ffffff;
  border: 1px solid #fe5e61;
  padding: 6px 10px;
  box-sizing: border-box;
}
.errorClass {
  margin-top: 0.5rem;
  font-size: 10px;
  color: #fe5e61;
}
input:focus {
  outline: none;
}
input:focus::placeholder {
  color: transparent;
}
input::placeholder {
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 20px;
  text-align: right;
  color: #74788d;
}
.labelStyle {
  min-width: 90px;
  max-width: 90px;
  margin-left: 10px;
  display: table;
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  color: #444444;
  justify-content: flex-start;
  align-items: center;
}

.secondLabelStyle {
  font-style: normal;
  font-weight: normal;
  font-size: 10px !important;
  color: #444444;
}

.subLabelStyle {
  margin-top: 0.2rem;
  font-weight: 700;
  font-size: 12px !important;
}

.label {
  display: flex;
  flex-direction: column;
  gap: 5px;
}
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type='number'] {
  -moz-appearance: textfield;
}

.label-no-width {
  min-width: 0 !important;
  padding-left: 18px !important;
}
</style>
